import { useIntl } from "react-intl";
import { Scheduling } from "../../models/schedule";

interface ICard {
    setShowDialog: (showDialog: boolean) => void;
    chooseScheduling: () => void;
    scheduling: Scheduling;
}

const Card = ({ setShowDialog, scheduling, chooseScheduling }: ICard) => {
    const intl = useIntl();
    return (
        <div
            className="alert alert-dismissible alert-info cursor-pointer my-10"
            onClick={() => {
                chooseScheduling();
                setShowDialog(true);
            }}
        >
            <div className="display-flex gap-10">
                <div className="w-full">
                    <div className="alert-header flex justify-between">
                        <strong>
                            {intl.formatMessage(
                                { id: "intl-msg:calendar.card.review" },
                                { description: scheduling.checkup?.description }
                            )}
                        </strong>
                        <strong>
                            {intl.formatTime(new Date(scheduling.date), { hour: '2-digit', minute: '2-digit' })}
                        </strong>
                    </div>
                    <div className="margin-y-5 flex flex-column">
                        <div>{scheduling.asset?.name}</div>
                        <div>
                            {intl.formatMessage({ id: "intl-msg:calendar.card.chassis" })} {scheduling.asset?.chassis}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Card;